import { showSideMenuUI, hideSideMenuUI, setInertByActiveMenus } from '../HeaderRelaunch2025/helper';

class BreadCrumbSiteMenuLink {
  constructor(options = {}) {
    this.element = options.element;
    this.headerElement = document.getElementById('headerTopMenu');
    this.sideMenu = document.getElementById('headerSideMenu');
    this.sideMenuNavContainer = this.sideMenu.querySelector('.nav');
    this.overlay = document.getElementById('sideMenuOverlay');
    this.menu1 = this.sideMenu.querySelector('.nav__menu-1');
  }

  init() {
    const breadcrumbLinks = [...this.element.querySelectorAll('.nav-breadcrumb__item-link')];

    breadcrumbLinks
      .slice(1) // Startseite überspringen
      .forEach((link) => {

        link.addEventListener('click', (event) => {
          const targetId = link.getAttribute('id');
          if (!targetId) {
            return;
          }

          event.preventDefault();
          window.scrollTo({ top: 0, behavior: 'instant' });

          showSideMenuUI(this.sideMenuNavContainer, this.overlay, this.headerElement);

          // gibt es ein Menü-2 mit dieser ID?
          const targetMenu2 = this.sideMenu.querySelector(`.nav__menu-2[data-id="${targetId}"]`);
          if (targetMenu2) {
            this.menu1.classList.remove('slide-in');
            this.menu1.classList.add('menu2IsOpen');
            targetMenu2.classList.add('slide-in');
            setInertByActiveMenus(this.sideMenu);
            this.sideMenuNavContainer.removeAttribute('inert');
            this.menu1.removeAttribute('inert');
            targetMenu2.removeAttribute('inert');

            // eslint-disable-next-line no-restricted-globals
            setTimeout(() => {
              this.focusFirstInMenu(targetMenu2);
            }, 300);

            return;
          }

          // gibt es ein Menü-3 mit dieser ID?
          const targetMenus3 = this.sideMenu.querySelectorAll(`.nav__menu-3[data-id="${targetId}"]`);
          const parentMenu2 = this.sideMenu.querySelector(`.nav__menu-2 button[id="${targetId}"]`).closest('.nav__menu-2');

          if (parentMenu2 && targetMenus3.length > 0) {
            this.menu1.classList.add('menu3IsOpen');
            parentMenu2.classList.add('menu3IsOpen');
            targetMenus3.forEach(element => element.classList.add('slide-in'));
            targetMenus3.forEach(element => element.removeAttribute('inert'));
            setInertByActiveMenus(this.sideMenu);
            this.sideMenuNavContainer.removeAttribute('inert');
            this.menu1.removeAttribute('inert');
            parentMenu2.removeAttribute('inert');

            // eslint-disable-next-line no-restricted-globals
            setTimeout(() => {
              this.focusFirstInMenu(targetMenus3[0]);
            }, 300);
          }
        });
      });

    // Fokus überwachen und Menü schließen, wenn Fokus außerhalb liegt
    document.addEventListener('focus', (event) => {
      const target = event.target;

      // Prüfen: Fokus liegt außerhalb des Menüs?
      const isOutside = !this.sideMenu.contains(target);

      if (isOutside) {
        this.menu1.classList.remove('slide-in', 'menu2IsOpen', 'menu3IsOpen');
        this.sideMenu.querySelectorAll('.nav__menu-2, .nav__menu-3')
          .forEach((menu) => {
            menu.classList.remove('slide-in', 'slide-out', 'menu2IsOpen', 'menu3IsOpen');
          });

        this.sideMenu.querySelectorAll('.nav, .nav__lang, .nav__menu-1, .nav__menu-2, .nav__menu-3')
          .forEach((menu) => {
            menu.setAttribute('inert', ''); // alle Menus inaktiv
          });
        hideSideMenuUI(this.sideMenuNavContainer, this.overlay, this.headerElement);
      }
    });
  }

  // Fokussteuerung
  focusFirstInMenu(menuEl) {
    if (!menuEl) {
      return;
    }

    const firstFocusable = menuEl.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');

    if (firstFocusable) {
      firstFocusable.focus();
    } else {
      // Fallback: Fokus auf Menücontainer
      menuEl.focus();
    }
  }
}

export default BreadCrumbSiteMenuLink;
